import React, { FC, useState } from 'react'
import { classNames, format } from '@dt/fe-utils'
import { observer } from 'mobx-react'
import { cartMobx, orderMobx } from 'restaurant'
import { ProductImage } from 'components'
import { Avatar, Icon } from '@cps'
import { buyTogetherMobx, multiPersonMobx } from '@mobxStore'
import { TEnumUserStatus } from '@mobx/cashier/multiPerson.mobx'
import { filter } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  user: string;
  list: any[];
  isSelf?: boolean;
  handleOutCart?: () => void;
}

const ProductItem: FC<IProps> = ({ user, list = [], isSelf, handleOutCart }) => {
  const [hasMore, setHasMore] = useState(false)
  const handleAdd = () => {
    buyTogetherMobx.onSelectMenu()
  }

  const getStatus = (user) => {
    const status = multiPersonMobx.multiPersonMap?.[user]?.status !== TEnumUserStatus.menu && list.length > 0 ? TEnumUserStatus.success : multiPersonMobx.multiPersonMap?.[user]?.status || TEnumUserStatus.init
    // return '为点单'
    const btnBox = (
      <>
        {(multiPersonMobx.currentPersonInfo.isOwner || !orderMobx.order.ordersId) && <div className='btn btn-quit' data-cypid='bt-cart-out' onClick={handleOutCart}>{i18n.t('menu.buyTogether.outbuytogether')}</div>}
        {
          !orderMobx.order.ordersId && (
            cartMobx.viewUserCartItems[user]?.length ? (
              <div className='btn btn-edit' data-cypid='bt-cart-revise-menu' onClick={handleAdd}>{i18n.t('menu.buyTogether.reviseMenu')}</div>
            ) : (
              <div className='btn btn-order' data-cypid='bt-cart-go-menu' onClick={handleAdd}>{i18n.t('menu.buyTogether.goMenu')}</div>
            )
          )
        }
      </>
    )
    return (
      <div className='btn-box'>
        {
          isSelf ? btnBox : (status !== 'success' || orderMobx.order.ordersId) ? <div className='status-txt'>{i18n.t(`menu.buyTogether.${status}Status`)}</div> : <div className='btn' data-cypid='bt-cart-copy-products' onClick={() => { copyCartItems(user) }}>{i18n.t('menu.buyTogether.copyCart')}</div>
        }
      </div>
    )
  }
  const copyCartItems = (user) => {
    const userViewCartItems = filter(cartMobx.viewCartItems, cartItem => cartItem.addUserId === String(user))
    const userCartItems: string[] = userViewCartItems.map(cartItem => cartItem.pk)
    if (buyTogetherMobx.checkAddCart(userViewCartItems)) return
    cartMobx.replace(userCartItems)
  }
  const getCartItem = (item) => {
    return (
      <div key={item.fkey || item.pk} className='products-item'>
        <ProductImage width={40} imgSrc={item.pic} />
        <div className='products-item-info'>
          <div className='left-wrap'>
            <div className='product-name'>{item.name || item.productName}</div>
            <div className='desc'>{item.optionStr}</div>
          </div>
          <div className='right-wrap'>
            <div className='price-wrap'>
              {/* <div dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.totalPrice || item.paidFee) }}></div> */}
              <div className='price-box' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.actualPrice || item.paidFee) }}></div>
              {item.actualPrice !== item.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.totalPrice) }}></del> : ''}
            </div>
            <div className='cnt'>{i18n.t('newCart.givenCnt', { cnt: item.cnt })}</div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={classNames('btcart-person-item', { more: hasMore })} key={`_${user}`}>
      <div className='person-info'>
        <Avatar key={user} userKey={user} />
        <div className='name'>{multiPersonMobx.multiPersonMap[user]?.nickName}{isSelf ? '（我）' : ''}</div>
        <div className='status'>{getStatus(user)}</div>
      </div>
      {
        list.length > 0 && (
          <div className='products-list'>
            {
              list.map(item => {
                return getCartItem(item)
              })
            }
          </div>
        )
      }
      {hasMore && (
        <div className='more-btn-wrapper'>
          <div className='more-btn-wrap' data-cypid='bt-cart-product-show-more' onClick={() => setHasMore(false)}>
            <span>{i18n.t('menu.buyTogetherTip.moreList')}</span>
            <Icon name='jiantou' />
          </div>
        </div>
      )}
    </div>
  )
}

export default observer(ProductItem)
